<template>
	<footer
		:style="[$_appViewPosition_positionBottom]"
		v-if="user && order"
		class="tag-partner"
		:class="{'hidden' : $route.name =='cookbook-recipe'}"
	>
		<div
			class="footer flex-vcenter"
			:class="{ 'mobile': !$mq.isDesktop() }"
		>
<!-- 			<template
				v-if="order"
			>
				<div
					class="tot-price"
					:class="{ 'mobile': !$mq.isDesktop() }"
				>
					<div
						v-if="orderHasDiscount"
						class="new-price"
					>
						{{ order.prices.net | priceFilter }}
					</div>
	
					<div
						:class="{ 'old-price': orderHasDiscount }"
					>
						<span
							v-if="orderHasDiscount"
							v-html="`invece di `"
						/>
						<span
							:class="{ 'strike': orderHasDiscount }"
							v-if="order.prices"
						>
							{{ order.prices.gross | priceFilter }}
						</span>
					</div>
				</div>

				<div
					v-if="$mq.isDesktop()"
				>
					<div>
						Kit Ricette: {{ order.prices.plan | priceFilter }} <span v-if="recipes.length >= 1">(<b>{{ order.getPlanPricePerPortion() | priceFilter }}</b> a porzione) </span>
						<info-tooltip
							style='font-size: 14px'
							:src="`Aggiungi ricette e ottieni il <b>miglior prezzo a porzione!</b>`"
							direction='top'
						/>
						
					</div>
					<div v-if="order.prices.recipes > 0">
						Premium: {{ order.prices.recipes | priceFilter }}
					</div>
					<div
						v-if="order.extras.length > 0"
					>
						Altri prodotti: {{ order.prices.extras | priceFilter }}
					</div>
					<div
						v-if="orderHasDiscount"
					>
						Sconto: -{{ order.prices.discount | priceFilter }}
					</div>

					<div
						v-if="order.prices.delivery > 0"
						v-html="`Consegna: ${ deliveryPrice }`"
					/>

					<div v-else>
						Consegna: <span class="delivery-free">GRATUITA</span>
					</div>
				</div>
			</template> -->

			<template>	
				<div class="flex px-3 py-2 checkout-prices" v-if="!verifyPageFooter">
					<div class="flex align-items-center" >
						<span class="mr-2 text-bold" :class="{'ml-10' : $mq.isDesktop()}" v-html="`Ricette:`" style="color: var(--quomi-primary)" ></span>
						<span
								class="text-bold"
								v-if="order.recipes.length > 0"
						>
								{{ order.prices.plan | priceFilter}}
								<span 
									v-if="hasPremium" 
									style="color: var(--quomi-primary)"
									>
										(+ {{order.prices.recipes | priceFilter}} Premium)
									</span>
						</span>
						<span v-else class="text-bold">€ --,–</span>
					</div>
					<div class="flex-vcenter" v-if="recipesFooter">
						<span class="ml-3 mr-3 text-bold" style="color: var(--quomi-primary)" >A porzione:</span>
						<span
								class="text-bold mr-2"
								v-if="order.recipes.length > 0"
						>
								{{ order.getPlanPricePerPortion() | priceFilter }}
						</span>
						<span v-else class="text-bold pr-5">€ --,–</span>
					</div>
					<div>
						<span class="mx-3 text-bold" v-if="!recipesFooter" style="color: var(--quomi-primary)" >Bottega:</span>
						<span
							class="text-bold"
								v-if="order.extras.length > 0 && !recipesFooter"
						>
							{{ order.prices.extras| priceFilter}}
						</span>
						<span v-if="order.extras.length <= 0 && !recipesFooter" class="text-bold">€ --,–</span>
					</div>
				</div>
				<span 
					class="px-10 text-center text-bold text-body-small m-auto min-alert"
					style="color: var(--quomi-orange); " 
					v-if="$route.path !== '/checkout/ricette' && !order.prices.min_reached" 
					v-html="'Raggiungi '+ this.order.prices.min_gross+ '€ di spesa per andare alla cassa!'"
				/>
				<div 
					class="pl-15 pr-13 text-center text-bold m-auto min-alert"
					:class="{'pt-3 pb-4' : !$mq.isDesktop()}"
					v-if="orderHasDiscount"
				>
					<span class="discount-alert">
						<span style="color: var(--quomi-primary)">Totale: </span>
						<span :style="order.prices.net !== '0.00' ? 'color: var(--quomi-red)' : ''">{{order.prices.net | priceFilter}}</span>
						<span v-if="order.prices.net !== '0.00'"> 
							(invece di
								<span style="text-decoration: line-through">{{order.prices.gross | priceFilter}}</span>
							)
						</span>
					</span>
				</div>
				<div class="flex-vcenter py-3 ml-10" v-if="verifyPageFooter && !orderHasDiscount">
						<span class="mr-5 text-bold" style="color: var(--quomi-primary)" >Totale:</span>
						<span
								class="mr-5 text-bold"
						>
								{{ order.prices.net | priceFilter }}
						</span>
					</div>		

			</template>

			<div
				class="flex-vcenter flex"
				:class="{ 'flex-right': $mq.isDesktop() }"	
				v-if="order"	
			>
				<!-- <billing-cart class="mt-1 mr-7" v-if="!$mq.isDesktop()" /> -->

				<CTA
					v-show="recipesFooter && !verifyPageFooter"
					isWithLoader
					isArrow
					class="recipe-cta"
          :class="{ 'mobile': !$mq.isDesktop() }"
					:loading="loading"
					:isDisabled="disabled"
					@click="!disabled && toShop()"
					:content="order.recipes.length > 0 || order.extras.length > 0   ? `Prosegui` : `Prosegui senza ricette`"
				/>

				<CTA
					v-show="!recipesFooter && !verifyPageFooter"
					isWithLoader
					isArrow
          :class="{ 'mobile mt-1': !$mq.isDesktop(), 'disabled': !order.prices.min_reached }"
					:loading="loading"
					:isDisabled="disabled"
					@click="!disabled && confirm()"
					:content="$route.name == 'subscription-step' ? `Salva e vai alla cassa`: 'Vai alla cassa'"
				/>

				<CTA
					v-show="verifyPageFooter"
					isWithLoader
					isArrow
          :class="{ 'mobile': !$mq.isDesktop(), 'disabled': !order.prices.min_reached }"
					:loading="loading"
					:isDisabled="disabled"
					@click="!disabled && done()"
					:content="`Conferma Ordine`"
				/>
 			</div>
		</div>

		<div
			class='alert-checkout-confirm green'
			v-if="noRecipesAlert"
			v-html="noRecipesAlert"
			:style="[$_appViewPosition_positionBottom]"
		/>
		<div
			class='alert-checkout-confirm'
			style='background: var(--quomi-orange)'
			v-if="priceMinAlert "
			v-html="priceMinAlert"
			:style="[$_appViewPosition_positionBottom]"
		/>
		<div
			class='alert-checkout-confirm'
			v-if="suspendAlert"
			v-html="suspendAlert"
			:style="[$_appViewPosition_positionBottom]"
		/>
	</footer>
</template>

<script type = "text/javascript">

import { prices } from '../../mixins/prices'
import InfoTooltip from '../Parts/InfoTooltip'
import BillingCart from './BillingCart'
import { plansStore } from '../../store/plansStore'
import { orderAction } from '../../mixins/orderAction'

export default {
	components: {
		InfoTooltip,
		BillingCart
	},
	props: {
		ctaLabel: {
			type: String
		},
		allowMinCheck: {
			type: Boolean,
			default: false
		},
		error: {
			type: String,
			default: null
		},
		loading: {
			type: Boolean,
			default: false
		},
		actionExecuted: {
			type: Boolean,
			default: false
		},
		recipesFooter: {
			type: Boolean,
			default: true
		},
		verifyPageFooter: {
			type: Boolean,
			default: false
		}
	},

	mixins: [
		prices,
		orderAction
	],

	data() {
		return {
			snackbar: false
		}
	},

	computed: {
		disabled () {
			return !this.isOrderOk
		},
		isOrderOk () {
			return !this.error && !this.priceMinAlert
		},
		recipes () {
			return this.order ? this.order.recipes : []
		},
		order () {
			return this.user.order
		},
		extras () {
			return this.order ? this.order.extras : []
		},
		user () {
			return this.$root.user
		},

		noRecipesAlert () {
			/*if (this.order && ((this.recipes.length <= 0) && (this.extras && this.extras.length <= 0))) {
				return this.$t('components.checkout.compose-box')
			}*/

			return null;
		},

		priceMinAlert () {

			if (this.allowMinCheck && this.order && !this.order.prices.min_reached) {

				if(this.order && this.order.discount && this.order.discount.group && this.order.discount.group.length > 0 && this.order.discount.group[0].coupon > 0) {

					return 'Raggiungi '+this.order.prices.min_gross+'€ di spesa per attivare il tuo codice!'

				}

				return 'Raggiungi '+this.order.prices.min_gross+'€ di spesa per andare alla cassa!'
			}

			return null;
		},

		suspendAlert () {

			if (!this.order || !this.order.id || !this.order.subscribed) return null

			if (this.error) return null

			/*
			if (this.isSkip) {
				return this.$t('components.checkout.compose-box')
			}

			if (this.isSuspended) {
				if (this.isTrial) {
					return this.$t('components.checkout.compose-box')
				}

				return this.$t('components.checkout.compose-box')
			}*/



			return this.isToConfirm ? `Conferma l'ordine, altrimenti le modifiche non verranno salvate!` : null
		},

		isTrial () {
			return this.user && this.user.subscription && this.user.subscription.trial
		},

		isSuspended () {
			return this.user && this.user.subscription && this.user.subscription.status === 'suspended'
		},

		isSkip () {
			return !this.isSuspended && this.order.status === 'skip'
		},
		
		isToConfirm () {
			return !this.isSuspended && !this.isSkip && this.order.is_need_confirm
		},

		confirmLabel () {
			return this.ctaLabel;

			if (!this.order) return 'Conferma'

			if (this.isSkip) return 'Attivati'

			if (this.isSuspended) return this.isTrial ? 'Attivati' : 'Conferma'

			if (this.isToConfirm) return 'Conferma'

			if (this.actionExecuted) return 'Conferma'

			return this.$route.params.referr === 'topSku' ? 'Vai al riepilogo' : 'Conferma'
		},

		hasPremium() {
			return this.order.recipes.some(el => el.product.sell_out[2] != 0)
		}
	},

	methods: {
		toShop() {
			this.$_orderAction_updateCurrentRecipes(0).then(() => {
				this.$router.push({ name: 'shop' })
			}).catch((error) => {
				console.log(error);
			});
		},

		confirm () {
			if(this.$route.name === 'subscription-step') {
          window.dispatchEvent(new CustomEvent('subscription-confirmed', { 
              bubbles: true,
          }));

					return this.$router.push({ name: 'verify-page' })
			}

			this.$_orderAction_updateCurrentRecipes(0).then(() => {
				if(this.order.prices.min_reached && this.user.subscription.is_pending) {
					return this.$router.push({ name: 'subscription-step' })
				}
				else if(this.order.prices.min_reached)  {
					return this.$router.push({ name: 'verify-page' })
				}
			}).catch((error) => {
				console.log(error);
			});
		},
		done() {
            window.dispatchEvent(new CustomEvent('verify-page-confirmed', { 
                bubbles: true,
            }));

            window.dispatchEvent(new CustomEvent('checkout-change-menu', { 
                bubbles: true,
                detail: (status) => {
                	
        			if (status === false) {
        				return
        			}
        			
        			this.$router.push({name: 'thank-you-recurring'})
        			
                }
            }));
        },
	}
}
</script>

<style scoped>

footer >>> .loading {
	transform: translate(-50%, -50%) scale(0.7);
}

footer {
	position: fixed;
	z-index: 3;
	bottom: 0;
	left: 0;
	width: 100%;
	background: #ffffff;
	box-shadow: 0 -1px 20px rgba(0, 0, 0, 0.12);
	-webkit-transition: -webkit-transform .3s;
	transition: -webkit-transform .3s;
	transition: transform .3s;
	transition: transform .3s, -webkit-transform .3s;
	transition: opacity .3s ease-out;
	font-size: 14px;
    line-height: 1.3;
}

.alert-checkout-confirm {
	position: absolute;
	bottom: 30px;
	background: black;
	left: 50%;
	transform: translateX(-50%);
	color: white;
	padding: 10px;
	border-radius: 4px;
	text-align: center;
}


.alert-checkout-confirm.green {
	background: var(--quomi-primary);
}


.checkout-prices {
	width: 35vw;
	justify-content: space-between;
}

footer .fa-angle-right {
	font-size: 16px;
	padding-left: 5px;
	padding-top: 2px;
}

.btn-green {
	position: relative;
	min-width: 300px;
}

.btn.mobile {
	margin: 0;
	border-radius: 0px;
	min-width: 300px;
	padding: 10px 25px;
}

.footer {
	padding: 0.3em 2em;
}

.footer.mobile {
	padding: 0 0 10px 0;
	flex-direction: column;
	align-items: center;
}

.tot-price {
	margin-right: 15px;
	font-size: 38px;
	font-weight: bold;
}

.tot-price.mobile,
.tot-price.mobile .new-price {
	font-size: 25px;
}

.new-price {
	font-size: 35px;
	color: red;
	line-height: 1.2;
}

.old-price {
	font-size: 15px;
	font-weight: normal;
}

.delivery-free {
	font-weight: bold;
	color: var(--quomi-primary);
}

.discount-alert {
		font-size: 14px;
}

@media (max-width: 1024px) {
	.alert-checkout-confirm {
		position: fixed;
		width: 100%;
		left: 0;
		transform: translateY(-55px);
		bottom: 0px;
		border-radius: 0;
		padding: 5px;
		font-weight: bold;
		font-size: 13px;
	}

	.checkout-prices {
		width: 45vw;
		justify-content: space-between;
	}

	.footer.mobile {
		padding: 20px 10px ;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}
}

@media (max-width: 768px) {
	.checkout-prices {
		width: 60vw;
		justify-content: space-around;
	}

	.footer.mobile {
		padding: 0 0 10px 0;
		flex-direction: column;
		align-items: center;
	}
}

@media (max-width: 640px) {
	.checkout-prices {
		width: 100vw;
		justify-content: center;
		font-size: 11px;
	}

	.min-alert {
		font-size: 10px !important;
	}

	.discount-alert {
		font-size: 10px;
	}
}

@media (max-width: 320px) {
	.checkout-prices {
		font-size: 9px;
	}

	.recipe-cta {
		margin: 0 10px;
		font-size: 13px;
	}
}

</style>
